module.exports = __webpack_public_path__ + "img/icon5.dd5754dc.png";